import { env as baseEnv } from "@repo/design-system/setup/env";
import { createEnv } from "@t3-oss/env-nextjs";
import { z } from "zod";

export const env = createEnv({
  extends: [baseEnv],
  client: {
    NEXT_PUBLIC_INDEX_GERMAN: z.string(),
    NEXT_PUBLIC_INDEX_ENGLISH: z.string(),
    NEXT_PUBLIC_INDEX_HUNGARIAN: z.string(),
    NEXT_PUBLIC_INDEX_SWEDISH: z.string(),
    NEXT_PUBLIC_INDEX_TCHECH: z.string(),
    NEXT_PUBLIC_INDEX_ROMANIAN: z.string(),
    NEXT_PUBLIC_INDEX_ITALIAN: z.string(),
    NEXT_PUBLIC_GOOGLE_VERIFICATION: z.string().optional(),
    NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID: z.string(),
  },
  server: {
    GOOGLE_CLIENT_ID: z.string(),
    GOOGLE_CLIENT_SECRET: z.string(),
    MICROSOFT_CLIENT_ID: z.string(),
    MICROSOFT_CLIENT_SECRET: z.string(),
    MICROSOFT_TENANT_ID: z.string(),
    TRANSLATIONS_TABLE_NAME: z.string(),
    TRANSLATIONS_SHEET_SHARE_LINK: z.string(),
    RESEND_API_KEY: z.string(),
    // IMAGE_PURGE_ALLOWED_SUBJECTS is read by @repo/image-purge (see packages/image-purge/README.md).
  },
  shared: {
    CLIENT: z.enum(["eon"]), // Primary client only - subclients (econ, eon-gridsolutions) should be defined in clientConfig
    ENVIRONMENT: z.enum(["production", "staging", "development"]),
  },
  experimental__runtimeEnv: {
    CLIENT: process.env.CLIENT,
    ENVIRONMENT: process.env.ENVIRONMENT,
    NEXT_PUBLIC_INDEX_GERMAN: process.env.NEXT_PUBLIC_INDEX_GERMAN,
    NEXT_PUBLIC_INDEX_ENGLISH: process.env.NEXT_PUBLIC_INDEX_ENGLISH,
    NEXT_PUBLIC_INDEX_HUNGARIAN: process.env.NEXT_PUBLIC_INDEX_HUNGARIAN,
    NEXT_PUBLIC_INDEX_SWEDISH: process.env.NEXT_PUBLIC_INDEX_SWEDISH,
    NEXT_PUBLIC_INDEX_TCHECH: process.env.NEXT_PUBLIC_INDEX_TCHECH,
    NEXT_PUBLIC_INDEX_ROMANIAN: process.env.NEXT_PUBLIC_INDEX_ROMANIAN,
    NEXT_PUBLIC_INDEX_ITALIAN: process.env.NEXT_PUBLIC_INDEX_ITALIAN,
    NEXT_PUBLIC_GOOGLE_VERIFICATION:
      process.env.NEXT_PUBLIC_GOOGLE_VERIFICATION,
    NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID:
      process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID,
  },
});
